import { render, staticRenderFns } from "./InfoPasajeroVuelta.vue?vue&type=template&id=37c311e0&scoped=true&"
import script from "./InfoPasajeroVuelta.vue?vue&type=script&lang=js&"
export * from "./InfoPasajeroVuelta.vue?vue&type=script&lang=js&"
import style0 from "./InfoPasajeroVuelta.vue?vue&type=style&index=0&id=37c311e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c311e0",
  null
  
)

export default component.exports